'use strict';

var variables = require('./variables-1eb6495a.js');
var colorManipulator = require('./colorManipulator-abc93889.js');

const light = {
    root: {
        borderWidth: 1,
        // Remove the focusVisible style set by IconButton
        "&.sprout-focus-visible": {
            borderColor: "transparent",
            boxShadow: `none`,
        },
        // Set focusVisible styling on the SVG wrapping element
        "&.sprout-focus-visible i": {
            borderRadius: 3,
        },
        // Regular unchecked checkboxes must be white
        "&:not($disabled)": {
            "&:not($checked)": {
                "&:not($indeterminate)": {
                    "& span": {
                        color: variables.COLORS.WHITE,
                    },
                },
            },
        },
        // Disabled checkboxes must be greyscale and have cursor set to not-allowed
        "&$disabled": {
            "& span": {
                pointerEvents: "auto",
                cursor: "not-allowed",
                color: variables.COLORS.GREYSCALE_0_25,
            },
        },
    },
    colorPrimary: {
        "&.sprout-focus-visible i": {
            borderColor: variables.COLORS.GREEN_PALE,
            boxShadow: `0 0 0 3px ${colorManipulator.alpha(variables.COLORS.GREEN_PALE, 0.5)}`,
        },
    },
    colorSecondary: {
        "&.sprout-focus-visible i": {
            borderColor: variables.COLORS.BLUE_PALE,
            boxShadow: `0 0 0 3px ${colorManipulator.alpha(variables.COLORS.BLUE_PALE, 0.5)}`,
        },
    },
};

var MuiCheckbox = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiCheckbox = MuiCheckbox;
exports.light = light;
